<template>
  <div class="document-scan-page" :class="cssClass" :style="cssStyle" 
  :oncontextmenu="isActiveContextMenu()">
    <!-- You have to use 'src' to remove outline border (or don't use img tag) -->
    <img
      v-if="!loaded"
      class="trobber_type"
      :class="infMiny"
      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAABGdBTUEAALGPC/xhBQAAAA1JREFUCB1j+Pz5838ACY8D2Typx+oAAAAASUVORK5CYII="
    />

    <img
      v-if="visible"
      class="document-scan-page__image"
      :src="imageUrl"
      alt=""
      @load="onImageLoad"
    />
    <template v-if="loaded && !showThumbnail">
      <a
        v-for="(link, linkIndex) in page.links"
        :key="linkIndex"
        class="document-scan-page__link"
        :class="{ '-expired': isDocumentDisabled(link.statusId) }"
        :href="link.url"
        :title="link.hint"
      >
        <span
          v-for="(rect, index) in link.rects"
          :key="linkIndex + '-' + index"
          class="document-scan-page__rect"
          :style="makeRectStyle(rect)"
        ></span>
      </a>
    </template>
    <mark
      v-for="(markRects, key) in marks"
      :key="'match' + key"
      class="document-scan-page__mark"
      :class="{ _current: markRects.id === currentMarkId }"
    >
      <span
        v-for="(rect, index) in markRects.coords"
        :key="key + ':' + index"
        class="document-scan-page__rect _mark"
        :style="makeRectStyle(rect)"
      ></span>
    </mark>
  </div>
</template>

<script>
import { DOCUMENT_STATUS_DISABLED } from '@src/api/documents';

export default {
  props: {
    /** @type {Object|ApiDocumentScanPage} */
    page: {
      type: Object,
      required: true
    },
    visible: {
      type: Boolean,
      default: false
    },
    showThumbnail: {
      type: Boolean,
      default: false
    },
    marks: {
      type: Array,
      default: null
    },
    currentMark: {
      type: Object,
      default: null
    },
    card: {
      type: Object,
      default: null
    },
  },

  data: () => ({
    imageLoaded: false
  }),

  computed: {
    currentMarkId() {
      return this.currentMark? this.currentMark.id: -1; 
    },
    loaded() {
      return this.visible && this.imageLoaded;
    },
    imageUrl() {
      return this.showThumbnail ? this.page.thumbUrl : this.page.url;
    },
    infMiny() {
      return {
        _miny: this.showThumbnail,
        _fully: !this.showThumbnail
      };
    },
    cssClass() {
      return {
        _thumbnail: this.showThumbnail,
        _loaded: this.loaded
      };
    },
    cssStyle() {
      let page = this.page,
        width = this.showThumbnail ? page.thumbWidth : page.width,
        height = this.showThumbnail ? page.thumbHeight : page.height;

      return {
        width: '100%',
        'max-width': `${width}px`
        // 'min-height': `${height}px`
      };
    }
  },

  methods: {
    /**
     * @param {ApiDocumentScanRect} r
     * @returns {string}
     */
    makeRectStyle(r) {
      return `top: ${r.y}%; left: ${r.x}%; width: ${r.w}%; height: ${r.h}%`;
    },
    isDocumentDisabled(statusId) {
      return statusId === DOCUMENT_STATUS_DISABLED;
    },
    onImageLoad() {
      this.imageLoaded = true;
    },
    isActiveContextMenu() {
      let citationAllowed = this.card.citationAllowed;
       return "return " + citationAllowed;
    }
  }
};
</script>

<style lang="scss">
._miny {
  min-width: 120px;
  max-width: 200px;
  min-height: 196px;
  max-height: 231px;
}

._fully {
  min-width: 320px;
  max-width: 800px;
  min-height: 596px;
  max-height: 1131px;
}

.trobber_type {
  width: 100%;
  height: 100%;

  vertical-align: top;
}
</style>
